import React from 'react';
import { Form, Row, Col, Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface FilterCriteria {
  name: string;
  description: string;
}

interface FilterToolsProps {
  onFilterChange: (criteria: FilterCriteria) => void;
}

const FilterComponent: React.FC<FilterToolsProps> = ({ onFilterChange }) => {
  const [filterCriteria, setFilterCriteria] = React.useState<FilterCriteria>({
    name: '',
    description: '',
  });
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilterCriteria(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilterChange(filterCriteria);
  };

  return (
    <Card.Body>
      <Form onSubmit={handleSubmit}>
        <Row className="align-items-end">
          <Col lg={5} md={4}>
            <Form.Group className="mb-0 text-nowrap">
              <Form.Label className="fs-5 fw-semibold text-secondary">{t("name")}</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={filterCriteria.name}
                onChange={handleChange}
                placeholder={t("name")}
                className='text-secondary bg-light fw-medium'
              />
            </Form.Group>
          </Col>
          <Col lg={5} md={4} className="ms-4">
            <Form.Group controlId="formDescription">
              <Form.Label className="fs-5 fw-semibold text-secondary">{t("description")}</Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={filterCriteria.description}
                onChange={handleChange}
                placeholder={t("tools.enterDescription")}
                className='text-secondary bg-light fw-medium'
              />
            </Form.Group>
          </Col>
          <Col md={1}>
            <Button variant="secondary" type="submit" className="px-4 py-1 fs-5 ms-4">{t("apply")}</Button>
          </Col>
        </Row>
      </Form>
    </Card.Body>
  );
};

export default FilterComponent;
